import request from "../utils/request";

export function processingTimeReport(company) {
  if (company) {
    return request({
      url: `/reports/processingTime/${company}`,
      method: "get",
    });
  } else {
    return request({
      url: `/reports/processingTime`,
      method: "get",
    });
  }
}

export function pendenciesReport(company) {
  if (company) {
    return request({
      url: `/reports/pendenciesPerUser/${company}`,
      method: "get",
    });
  } else {
    return request({
      url: `/reports/pendenciesPerUser`,
      method: "get",
    });
  }
}

export function thirdPartyPendenciesReport(company) {
  if (company) {
    return request({
      url: `/reports/pendenciesPerThirdParty/${company}`,
      method: "get",
    });
  }

  return request({
    url: `/reports/pendenciesPerThirdParty`,
    method: "get",
  });
}

export function committeeReport(company) {
  if (company) {
    return request({
      url: `/reports/committee/${company}`,
      method: "get",
    });
  } else {
    return request({
      url: `/reports/committee`,
      method: "get",
    });
  }
}

export function auditReportByProtocol(protocol) {
  return request({
    url: `/reports/audit/protocol/${protocol}`,
    method: "get",
  });
}

export function auditReportByUser(user) {
  return request({
    url: `/reports/audit/complaint/user/${user}`,
    method: "get",
  });
}

export function markAsRead(notification) {
  return request({
    url: `/notifications/${notification._id}`,
    method: "post",
    data: {
      read: true,
    },
  });
}

export function denouncedUsersReport(company) {
  if (company) {
    return request({
      url: `/reports/denouncedUsers/${company}`,
      method: "get",
    });
  }
  return request({
    url: `/reports/denouncedUsers`,
    method: "get",
  });
}

export function ombudsmanProcessingTimeReport(company) {
  if (company) {
    return request({
      url: `/reports/ombudsman/processingTime/${company}`,
      method: "get",
    });
  } else {
    return request({
      url: `/reports/ombudsman/processingTime`,
      method: "get",
    });
  }
}

export function timeCostReport(company, startDate = null, endDate = null) {
  console.log("API timeCostReport: Chamada feita", {
    company,
    startDate,
    endDate,
  });

  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  if (company) {
    console.log(
      "API timeCostReport: Fazendo requisição para empresa específica",
      `/reports/timeCost/${company}`
    );
    return request({
      url: `/reports/timeCost/${company}`,
      method: "get",
      params,
    });
  }
  console.log(
    "API timeCostReport: Fazendo requisição para todas as empresas",
    `/reports/timeCost`
  );
  return request({
    url: `/reports/timeCost`,
    method: "get",
    params,
  });
}

export function generatePdfReport(data) {
  return request({
    url: `/reports/generate-pdf`,
    method: "post",
    data,
    responseType: "blob",
  });
}

/**
 * Generate and download a DOCX report for complaints
 * @param {Object} params - Report parameters
 * @param {string} params.startDate - Start date (YYYY-MM-DD format)
 * @param {string} params.endDate - End date (YYYY-MM-DD format)
 * @param {number} [params.companyId] - Optional company ID filter
 * @param {string} [params.language='pt'] - Report language ('pt', 'en', 'es')
 * @returns {Promise} - Axios response with blob data
 */
export function generateComplaintsReportDocx(params) {
  return request({
    url: "/reports/complaints/pdf",
    method: "post",
    data: params,
    responseType: "blob",
  });
}

/**
 * Download a generated report by triggering a file download
 * @param {Object} response - Axios response object containing the blob
 * @param {string} filename - The filename for the download
 */
export function downloadReportBlob(response, filename) {
  // Handle both direct blob and axios response object
  const blob =
    response.data instanceof Blob ? response.data : new Blob([response.data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
